module.exports = "file-picture"